import { type MapBounds } from '@/packages/redux-state/store/slices/mapConfiguration/slice';

import { type IBBoxSchema } from '@/repositories/generated/shared/search-offers-index/entities/bbox/BBoxSchema';

export const convertMapBoundsToBbox = (bounds: MapBounds): IBBoxSchema => {
  const [[latMin, lngMin], [latMax, lngMax]] = bounds;

  return {
    bottomRight: { lat: latMin, lng: lngMax },
    topLeft: { lat: latMax, lng: lngMin },
  };
};
